import { STORAGE_KEYS } from "../utils/key_helper";
import { API_URL } from '../utils/constant';
// ------------------- HEADER BUILDER -------------------
function buildHeaders({ contentType } = {}) {
    const headers = new Headers();
    const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    if (token) headers.append("Authorization", token);
    if (contentType) headers.append("Content-Type", contentType);
    return headers;
}

// ------------------- BASE FUNCTIONS -------------------

// GET API → return full response
export async function makeGetApiRequest(path) {
    try {
        const options = {
            method: "GET",
            headers: buildHeaders({}),
        };
        const response = await fetch(`${API_URL}${path}`, options);
        const resData = await response.json();
        if (response.status === 401) {
            localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
            window.location.href = '/user/login';
        }
        if (!response.ok || resData.error) {
            return { error: resData.error?.data || resData.error || { message: "API failed" } };
        }
        return resData;  // full JSON response
    } catch (error) {
        console.error("GET API error:", error);
        return { error: { message: "Api request error", error } };
    }
}

// POST API → wrap inside { result }
export async function makeApiRequest(path, params) {
    // If params is already a string (JSON), use as is; otherwise stringify
    const bodyPayload = typeof params === 'string' ? params : JSON.stringify(params);

    try {
        const options = {
            method: "POST",
            body: bodyPayload,
            headers: buildHeaders({ contentType: "application/json" }),
        };

        const response = await fetch(`${API_URL}${path}`, options);
        const resData = await response.json();
        if (response.status === 401) {
            localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
            window.location.href = '/user/login';
        }

        if (!response.ok || resData.error) {
            return { error: resData.error?.data || resData.error || { message: "API failed" } };
        }

        return { result: resData };
    } catch (error) {
        console.error("POST API error:", error);
        return { error: { message: "Api request error", error } };
    }
}
//FORM REQUEST API 
export async function makeFormDataRequest(path, data) {
    const formData = new FormData();

    // Append all key-value pairs from data to FormData
    Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value);
    });

    try {
        var reqHeader = new Headers();
        reqHeader.append("Authorization", localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN));

        const response = await fetch(`${API_URL}${path}`, {
            method: "POST",
            body: formData,
            headers: reqHeader,
            redirect: "follow",
        });
        if (response.status === 401) {
            localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
            window.location.href = "/user/login";
        }
        const jsonResponse = await response.json();
        return jsonResponse;

    } catch (error) {
        console.error(error);
        return { status: false, msg: "API request error", error: error };
    }
}
// ------------------- UTILITY TO HANDLE POST RESPONSE -------------------

const handlePostResponse = response => {
    if (response?.result) return response.result;
    if (response?.error) throw new Error(response.error.message);
    throw new Error("Unknown error. Please try again.");
};

// ------------------- UTILITY TO HANDLE GET RESPONSE -------------------

const handleGetResponse = response => {
    if (response?.error) throw new Error(response.error.message);
    if (response) return response;
    throw new Error("Unknown error. Please try again.");
};
// ------------------- UTILITY TO HANDLE FORM DATA  RESPONSE -------------------

const handleFormDataResponse = response => {
    if (response?.status) return response;
    if (response?.error) throw new Error(response.message);
    throw new Error("Unknown error. Please try again.");
};
// -------------------------------------- AUTH   --------------------------------------

// V1 - USER LOGIN
export const UserLogin = async payload => handlePostResponse(await makeApiRequest("/auth/whitelabeluserlogin", payload))

// V1 - USER FORGOT PASSWORD
export const UserForgotPassword = async payload => handlePostResponse(await makeApiRequest("/auth/whitelabeluserforgotpassword", payload))

// V1 - USER REGISTRATION
export const UserRegistration = async payload => handlePostResponse(await makeApiRequest("/auth/whitelabeluserregister", payload));

// V1 - GET THEME
export const GetTheme = async payload => handlePostResponse(await makeApiRequest("/auth/gettheme", payload));

// -------------------------------------- USER PROFILE    --------------------------------------
//V1-  CHANGE PASSWORD
export const Changepassword = async payload => handlePostResponse(await makeApiRequest("/whitelabelusers/resetpassword", payload))


//V1- GET CONFIGS 
export const GetConfigs = async () => handleGetResponse(await makeGetApiRequest("/whitelabelusers/getconfigs"))

//V1- GET USER PROFILE 
export const GetUserProfile = async () => handleGetResponse(await makeGetApiRequest("/whitelabelusers/getprofile"))

//V1 - GET COUNTRIES
export const GetCountries = async () => handleGetResponse(await makeGetApiRequest("/users/getcountries"))
//V1 - UPDATE PROFILE
export const UpdateUserProfile = async payload => handleFormDataResponse(await makeFormDataRequest("/whitelabelusers/updateprofile", payload))


// -------------------------------------- BRIDGE    --------------------------------------
// V1 - UPDATE BRIDGE
export const UpdateBridge = async payload => handlePostResponse(await makeApiRequest("/users/bridge/updatebridge", payload))

// V1 -  UPDATE BRIDGE  TRADING FLAG
export const UpdateBridgeTradingFlag = async payload => handlePostResponse(await makeApiRequest("/users/bridge/updatebridgetradingflag", payload))

// V1 -  DISCONNECT BRIDGE 
export const DisconnectBridge = async payload => handlePostResponse(await makeApiRequest("/users/bridge/disconnectbridge", payload))

// V1 -  BRIDGE PLACE ORDER
export const BridgePlaceOrder = async payload => handlePostResponse(await makeApiRequest("/users/bridge/placebridgeorder", payload))

// V1 -  DELETE BRIDGE 
export const DeleteBridge = async payload => handlePostResponse(await makeApiRequest("/users/bridge/removebridge", payload))

// V1 - CONNECT BRIDGE 
export const ConnectBridge = async payload => handlePostResponse(await makeApiRequest("/users/bridge/connectbridge", payload))

// V1- REGENERATE BRIDGE KEY 
export const RegenerateBridgeKey = async payload => handlePostResponse(await makeApiRequest("/users/bridge/regeneratebridgekey", payload))

// V1- ADD BRIDGE 
export const AddBridge = async payload => handlePostResponse(await makeApiRequest("/users/bridge/addbridge", payload))

//V1- SEARCH SYMBOLS
export const SearchSymbols = async payload => handlePostResponse(await makeApiRequest("/symbols/searchsymbol", payload))

//V1- GET BRIDGE 
export const GetBridge = async () => handleGetResponse(await makeGetApiRequest("/users/bridge/getbridges"))

//V1- GET BRIDGE BY ID 
export const GetBridgeById = async payload => handlePostResponse(await makeApiRequest("/users/bridge/getbridgebyid", payload))

//V1- GET BRIDGE POSITION
export const GetBridgePositions = async payload => handlePostResponse(await makeApiRequest("/users/bridge/getbridgepositions", payload))

//V1- GET BRIDGE SIGNALS
export const GetBridgeSignals = async payload => handlePostResponse(await makeApiRequest("/users/bridge/getbridgesignals", payload))

//V1- TRAIDNG VIEW WEB HOOK SIMULATION
export const TradingViewWebHookSimulation = async (json_bridge_id, json_bridge_key, payload) => handlePostResponse(await makeApiRequest(`/users/bridge/webhook/tradingview/${json_bridge_id}/${json_bridge_key}`, payload))

// -------------------------------------- ACCOUNTS    --------------------------------------
//V1- GET ACCOUNTS
export const GetAccounts = async () => handleGetResponse(await makeGetApiRequest("/users/broker/getsubuserbrokers"))
//V1- GET ACCOUNT BY ID 
export const GetAccountById = async payload => handlePostResponse(await makeApiRequest("/users/broker/getbrokerbyid", payload))

//V1- GET MY ACCOUNTS NAMES
export const GetAccountsName = async () => handleGetResponse(await makeGetApiRequest("/users/broker/getwhitelabelbrokernames"))

//V1- GET ACCOUNT FOR SUBSCRIPTIONS
export const GetAccountForSubscriptions = async payload => handlePostResponse(await makeApiRequest("/users/broker/getbrokerforsubscriptions", payload))

//V1- GET ACCOUNT QUEUE
export const GetAccountQueue = async () => handleGetResponse(await makeGetApiRequest("/users/broker/getbrokerqueue"))
//V1- CANCEL ACCOUNT QUEUE BY ID 
export const GetAccountQueueById = async payload => handlePostResponse(await makeApiRequest("/users/broker/getbrokerqueuebyid", payload))

//V1- CANCEL ACCOUNT QUEUE
export const CancelAccountQueue = async payload => handlePostResponse(await makeApiRequest("/users/broker/cancelbrokerqueue", payload))

//V1-  DELETE ACCOUNT QUEUE 
export const DeleteAccountQueue = async payload => handlePostResponse(await makeApiRequest("/users/broker/removebrokerqueue", payload))

// V1 - ADD ACCOUNT
export const AddAccount = async payload => handlePostResponse(await makeApiRequest("/users/broker/addbroker", payload))

// V1 - UPDATE ACCOUNT TRADING STATUS
export const UpdateAccountTradingStatus = async payload => handlePostResponse(await makeApiRequest("/users/broker/updatebrokertradingflag", payload))

// V1 - UPDATE ACCOUNT AUTO RENEW STATUS
export const UpdateAccountAutoRenewStatus = async payload => handlePostResponse(await makeApiRequest("/users/broker/updatebrokerautorenew", payload))

// V1 - EXTEND ACCOUNT
export const ExtendAccount = async payload => handlePostResponse(await makeApiRequest("/users/broker/extendbroker", payload))

// V1 - RECONNECT ACCOUNT
export const ReconnectAccount = async payload => handlePostResponse(await makeApiRequest("/users/broker/reconnectbroker", payload))

// V1 - REFRESH ACCOUNT
export const RefreshAccount = async payload => handlePostResponse(await makeApiRequest("/users/broker/refreshbroker", payload))

// V1 - RENEW ACCOUNT
export const RenewAccount = async payload => handlePostResponse(await makeApiRequest("/users/broker/renewbroker", payload))
// V1 - FRESH  ACCOUNT
export const FreshAccountData = async payload => handlePostResponse(await makeApiRequest("/users/broker/refreshaccountdata", payload))

// V1 - SET ACCOUNT SL AND TP 
export const SetAccountSLTP = async payload => handlePostResponse(await makeApiRequest("/users/broker/setslandtp", payload))

// V1 - DELETE ACCOUNT
export const DeleteAccount = async payload => handlePostResponse(await makeApiRequest("/users/broker/deletebroker", payload))

// V1 - GET ACCOUNT POSITION
export const GetAccountPositions = async payload => handlePostResponse(await makeApiRequest("/users/broker/getpositions", payload))

// V1 - GET ACCOUNT PENDING ORDERS
export const GetAccountPendingOrders = async payload => handlePostResponse(await makeApiRequest("/users/broker/getpendingorders", payload))

// V1 - GET ACCOUNT HISTORICAL DATA
export const GetAccountHistoricalData = async payload => handlePostResponse(await makeApiRequest("/users/broker/gethistoricaldealsdata", payload))

// V1 - SQUARE OFF ACCOUNT POSITION
export const SquareOffAccountPosition = async payload => handlePostResponse(await makeApiRequest("/users/broker/squareoff", payload))

// V1 - SQUARE OFF ACCOUNT ALL POSITION
export const SquareOffAllPositionsInAccount = async payload => handlePostResponse(await makeApiRequest("/users/broker/squareoffall", payload))

// V1 - EDIT ACCOUNT ORDER
export const EditOrderInAccount = async payload => handlePostResponse(await makeApiRequest("/users/broker/modifyorder", payload))

// V1 - ACCOUNT ORDER CANCEl
export const CancelAccountOrder = async payload => handlePostResponse(await makeApiRequest("/users/broker/cancelorder", payload))

// V1 - ACCOUNT ORDER CANCEl ALL
export const CancelAllOrdersInAccount = async payload => handlePostResponse(await makeApiRequest("/users/broker/cancelallorders", payload))

// V1 - PLACE ORDER
export const PlaceOrder = async payload => handlePostResponse(await makeApiRequest("/users/broker/placeorder", payload))


// --------------------------------------WALLET --------------------------------------

// V1 - GET WALLET 
export const GetWallet = async payload => handlePostResponse(await makeApiRequest("/whitelabelusers/getledger", payload))

// --------------------------------------ACTIVITY LOGS  --------------------------------------

// V1 - GET USER ACTIVITY LOGS  
export const GetUserActivityLogs = async payload => handlePostResponse(await makeApiRequest("/whitelabelusers/getactivities", payload))

// -------------------------------------- STRATEGY    --------------------------------------
//V1- GET STRATEGY 
export const GetStrategy = async () => handleGetResponse(await makeGetApiRequest("/whitelabelusers/strategies/getstrategies"))

// V1 - GET STRATEGY PLANS
export const GetStrategyPlan = async payload => handlePostResponse(await makeApiRequest("/whitelabelusers/strategies/getstrategyplans", payload))

// V1 - GET SUBSCRIBE STRATEGY
export const SubscribedStrategy = async payload => handlePostResponse(await makeApiRequest("/whitelabelusers/strategies/subscribestrategy", payload))

// V1 - GET SUBSCRIBE BY ID 
export const GetStrategyById = async payload => handlePostResponse(await makeApiRequest("/whitelabelusers/strategies/getstrategybyid", payload))

// V1 - GET STRATEGY RECORDS 
export const GetStrategyRecords = async payload => handlePostResponse(await makeApiRequest("/whitelabelusers/strategies/getstrategyrecords", payload))

// V1 - GET STRATEGY Orders 
export const GetStrategyOrders = async payload => handlePostResponse(await makeApiRequest("/whitelabelusers/strategies/getstrategyorderhistory", payload))

//V1- GET SUBSCRIBED STRATEGY 
export const GetSubscribedStrategy = async () => handleGetResponse(await makeGetApiRequest("/whitelabelusers/strategies/getsubscribedstrategies"))


// V1 - UPDATE STRATEGY TRADING STATUS
export const UpdateStrategyTradingStatus = async payload => handlePostResponse(await makeApiRequest("/users/group/updatechildtradingflag", payload))

// V1 - UPDATE ACCOUNT TO MY STRATEGY
export const UpdateAccountToSubscribedStrategy = async payload => handlePostResponse(await makeApiRequest("/whitelabelusers/strategies/updatebrokertosubscribedstrategy", payload))

// V1 - UPDATE STRATEGY LOT SIZE
export const UpdateStrategyLotSize = async payload => handlePostResponse(await makeApiRequest("/users/group/updategroupbroker", payload))

// V1 - RENEW STARTEGY SUBSCRIPTION
export const RenewStrategySubscription = async payload => handlePostResponse(await makeApiRequest("/whitelabelusers/strategies/renewstrategysubscription", payload))

// -------------------------------------- ORDER HISTORY --------------------------------------
// V1 - GET ORDER HISTORY
export const GetOrderHistory = async payload => handlePostResponse(await makeApiRequest("/whitelabelusers/getorderhistory", payload))

// --------------------------------------REFERRAL --------------------------------------
//V1- GET REFERRAL DATA
export const GetReferralData = async () => handleGetResponse(await makeGetApiRequest("/whitelabelusers/getreferraldata"))

// V1 - GET REFERRAL EARNINGS
export const GetReferralEarning = async payload => handlePostResponse(await makeApiRequest("/whitelabelusers/getreferralearnings", payload))


// --------------------------------------DASHBOARD --------------------------------------
//V1- GET DASHBOARD
export const GetDashbaord = async () => handleGetResponse(await makeGetApiRequest("/whitelabelusers/getdashboard"))
